import { Switch } from "react-router-dom";
import SolicitacaoCadastroPages from "./SolicitacaoCadastro";
import AssembleiasPages from "./AssembleiasPages";
import MensagensPages from "./Mensagens";
import PortariaListagemPage from "./Portaria";
import ReservasPages from "./Reservas";
import MuralPages from "./Mural";
import AnunciosPages from "./Anuncios/index";
import AuthRoute from "ui/components/AuthRoute";
import { PermissaoEnum } from "core/resources/enums/permissao";
import ParceirosPages from "./Parceiros/index";
import EncomendaPages from "./Encomendas/index";
import EquipamentosPages from "./Equipamentos/index";
import ManutencaoListaPage from "./ControleManutencao/Listagem";
import OrcamentosPages from "./Orcamento/index";

function AdministracaoPages() {
  return (
    <Switch>
      <AuthRoute
        path="/administracao/portaria"
        component={PortariaListagemPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
        ]}
      />
      <AuthRoute
        path="/administracao/mensagens"
        component={MensagensPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar,
          PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
        ]}
      />
      <AuthRoute
        path="/administracao/reservas"
        component={ReservasPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar,
        ]}
      />
      <AuthRoute
        path="/administracao/assembleias"
        component={AssembleiasPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Votacao.Visualizar,
        ]}
      />
      <AuthRoute
        path="/administracao/solicitacao-cadastro"
        component={SolicitacaoCadastroPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.SolicitacaoCadastro
            .Visualizar,
        ]}
      />
      <AuthRoute
        path="/administracao/mural"
        component={MuralPages}
        permissions={[PermissaoEnum.Backoffice.Administrativo.Mural.Visualizar]}
      />

      <AuthRoute
        path="/administracao/anuncios"
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Anuncio.Visualizar,
        ]}
        component={AnunciosPages}
      />

      <AuthRoute
        path="/administracao/parceiros"
        permissions={[PermissaoEnum.Backoffice.Admin.Parceiro.Visualizar]}
        component={ParceirosPages}
      />

      <AuthRoute
        path="/administracao/encomenda"
        component={EncomendaPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Encomenda.Visualizar,
        ]}
      />

      <AuthRoute
        path="/administracao/patrimonio"
        component={EquipamentosPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Equipamento.Visualizar,
        ]}
      />

      <AuthRoute
        path="/administracao/manutencao"
        component={ManutencaoListaPage}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Manutencao.Visualizar,
        ]}
      />

      <AuthRoute
        path="/administracao/orcamento"
        component={OrcamentosPages}
        permissions={[
          PermissaoEnum.Backoffice.Administrativo.Orcamento.Visualizar,
        ]}
      />
    </Switch>
  );
}

export default AdministracaoPages;
